<template lang="html">
    <div class="view-home">
        <div class="block-company">
            <div v-if="urlBackToPortal" class="back-to-portal">
                <a :href="urlBackToPortal"> < Retour au portail</a>
            </div>
            <div class="block-company-content">
                <div class="block-company-gradient"></div>
                <div class="block-company-text">
                    <div v-if="userSite">
                        <h1>{{ userSite.facility_name }}</h1>
                        <h2>{{ userSite.company_name }}</h2>
                    </div>
                    <div v-else>
                        <h1>Sélection du site</h1>
                        Veuillez choisir le site auquel vous voulez vous connecter
                    </div>
                </div>
            </div>
        </div>
        <div class="home-layout" v-if="!userSite">
            <el-row>
                <el-col
                    :xs="24"
                    :sm="24"
                >
                    <el-button
                        v-if="userIsAtLeastManager"
                        style="font-size: 20px;"
                        type="primary"
                        class="btn-edit"
                        icon="el-icon-plus"
                        @click="createSite"
                    >
                        Créer un nouveau site
                    </el-button>
                    <br>
                    <br>
                    <br>
                </el-col>

                <div v-if="site.length===0">
                    <h3>Vous n'avez aucun site</h3>
                </div>

                <div v-if="site.length > 0">
                    <br>
                    Sélectionnez un site
                    <el-input
                        v-model="search"
                        placeholder="Rechercher"
                        class="input-search"
                    ></el-input>
                    <div class="sites-list">
                        <el-card
                            v-for="(_site, index) in site"
                            :key="index"
                        >
                            <div
                                class="sites-list__header"
                            >
                                <p class="sites-list__header__name">
                                    {{_site.facility_name}}
                                </p>
                                <div class="sites-list__buttons-container">
                                    <el-button
                                        icon="el-icon-edit"
                                        round
                                        type="info"
                                        @click="editSite(_site)"
                                    ></el-button>
                                    <el-button
                                        icon="el-icon-delete"
                                        round
                                        type="danger"
                                        plain
                                        @click="archiveSite(_site)"
                                    ></el-button>
                                </div>
                            </div>
                            <hr>
                            <div>
                                <div class="sites-list__button-container">
                                    <el-button
                                        type="primary"
                                        @click="setSite(_site)"
                                    >
                                        SÉLECTIONNER
                                    </el-button>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </div>
            </el-row>
        </div>
        <div v-else class="padding flex">
            <div>
                <el-row>
                    <el-col
                        :xs="12"
                        :sm="12"
                    >
                        <el-button
                            style="font-size: 1em;"
                            class="btn-edit"
                            type="text"
                            icon="el-icon-arrow-left"
                            @click="unsetSite"
                        >
                            Sélectionner un autre site
                        </el-button>
                    </el-col>
                    <el-col
                        :xs="12"
                        :sm="12"
                    >
                        <el-button
                            style="font-size: 1em; margin-left: auto; display: block;"
                            class="btn-edit"
                            type="text"
                            @click="archiveSite"
                        >
                            Supprimer ce site
                            <i class="el-icon-delete icon"></i>
                        </el-button>
                    </el-col>
                </el-row>
                <div>
                    <HomeTile
                        title="Mon site"
                        subtitle="informations du site"
                        icon="industry"
                        route="Site"
                    >
                    </HomeTile>
                </div>
                <div
                    v-if="hasMotors"
                    class="motor-cards"
                >
                    <Motors
                        :site-uid="currentSite.uid"
                    >
                    </Motors>
                </div>
                <div v-else>
                    <p class="no-motor">Aucun moteur n'a été créé</p>
                </div>
            </div>
            <div>
                <el-button
                    class="add-motor"
                    icon="el-icon-plus"
                    @click="addNewMotor"
                >
                    Ajouter un moteur
                </el-button>
                <div class="legend-container">
                    <div class="legend">
                        <div class="legend-square simple"></div> Mode simple
                    </div>
                    <div class="legend">
                        <div class="legend-square advanced"></div> Mode Avancé
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HomeTile from './HomeTile';
import Motors from './motors/Index.vue';


export default {
    name: 'Home',
    
    components: {
        HomeTile,
        Motors,
    },
    
    data (){
        return {
            verboseStatus: {
                'VALIDATED': 'VALIDÉ',
                'PREPARED': 'PRÉPARÉ',
                'SHIPPED': 'EXPÉDIÉ',
                'AUDITED': 'AUDITÉ',
                'RECEIVED': 'REÇU',
                'PENDING': 'EN ATTENTE',
            },
            siteForm: {
                facility_name: '',
                company_name: '',
            },
            auditForm: {
                name: '',
                motorbox_count: 0,
                date: '',
            },
            search: '',
            displayMotorForm: false,
        };
    },
    
    computed: {
        ...mapGetters([
            'currentSite',
            'site',
            'userByUid',
            'currentUser',
            'userIsAtLeastManager',
            'motors',
            'applicationMode'
        ]),
        hasMotors(){
            let relatedMotors = this.motors.filter((motor) => motor.site_uid === this.userSite.uid);
            return relatedMotors.length > 0;
        },
        userSite () {
            if (this.currentSite){
                return this.currentSite;
            }
        },
        urlBackToPortal(){
            return window.config.master_page_url;
        },
    },
    
    methods: {
        editSite(site){
            this.$router.push({
                name: 'Site',
                params: {
                    siteUid: site.uid
                }
            });
            this.$store.commit('SET_CURRENT_SITE', site);
        },
        addNewMotor(){
            let siteUid = this.currentSite.uid;
            if(this.applicationMode === 'advanced'){
            this.$router.push({name: 'AdvancedMotorForm', params: { siteUid: siteUid }});
            }else{
                this.$router.push({name: 'AdvancedMotorForm', params: { siteUid: siteUid }});
            }
        },
        setSite(site){
            this.$store.commit('SET_CURRENT_SITE', site);
        },
        unsetSite(){
            this.$store.commit('UNSET_CURRENT_SITE');
        },
        createSite(){
            this.unsetSite();
            this.$router.push({name: 'Site'});
        },
        archiveSite(selectedSite=null){
            var site = this.userSite ? this.userSite : selectedSite;
            this.$confirm('Voulez-vous vraiment supprimer ce site ?', site.company_name, {
                type: 'warning',
                confirmButtonText: 'Confirmer',
                cancelButtonText: 'Annuler',
            })
            .then(() =>{
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: site.url,
                    },
                    model: 'site',
                    url: this.$store.state.api.meta.listModels.site.url,
                })
                .then(() => {
                    this.$store.dispatch(
                        'reloadModels',
                        {site}
                    ).then(() => {
                        this.unsetSite();
                        this.$notify({
                            title: 'Supprimé',
                            message: 'Le site a été supprimé',
                            type: 'success',
                            duration: 3000,
                        });
                    });
                })
                .catch(() => {
                    this.$notify({
                        title: 'Erreur',
                        message: 'Le site n\'a pas pu être supprimé',
                        type: 'success',
                        duration: 3000,
                    });
                });
            }).catch(() => {
                return;
            });
        },
        updateApplicationMode(mode){
            this.$store.dispatch('updateApplicationMode', mode);
        }
    },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';

.block-company {
    position: relative;
    background: $--color-primary;
    background: url('../../../../static/images/img-bandeau-motor-view.jpg') no-repeat center center;
    background-size: cover;
    color: white;
    h1 {
        font-size: 40px;
        line-height: 40px;
        margin-bottom: 0;
    }
    h2 {
        font-size: 20px;
        line-height: 20px;
        text-transform: uppercase;
    }
    .block-company-text {
        display: block;
        position: relative;
        max-width: $layout-width;
        margin: auto;
        padding: 0 20px;
    }
    .block-company-content {
        display: block;
        position: relative;
        padding: 80px 0 20px;
    }
    .block-company-gradient {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(to bottom, rgba(#000,0) 0%,rgba(#000,0.3) 100%);
    }
}

.price-box {
    h3 {
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        padding: 20px 0 30px;
        .mwh-unit {
            font-size: 12px;
            vertical-align: super;
        }
    }
}

.description-list {
    margin: 0;
    dt {
        font-size: 12px;
        color: #ccc;
    }
    dd {
        margin: 0;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    a {
        color: $--color-primary;
    }
}

.view-home {
    .home-subnav {
        padding: 20px;
        padding-top: 0;
        .el-tooltip.el-button.el-button--text{
            padding: 0;
        }
    }
    .btn-download-motor-file{
        margin-bottom: 30px;
    }
}
.sites-list{
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    &__header{
        display: flex;
        justify-content: space-between;
        &__name{
            width: 15rem;
            color: #303133;
            font-weight: 500;
            font-size: 20px;
            overflow-wrap: break-word;
            word-wrap: break-word;
            margin: 0;
        }
    }
    .el-card{
        width: 30rem;
        height: 22rem;
        overflow: scroll;
    }
    &__button-container{
        text-align: center;
        margin-top: 4rem;
        .el-button{
            width: 100%;
        }
    }
    &__buttons-container{
        .el-button{
            margin: 0;
            padding: 1rem;
        }
    }
}
.input-search {
    margin-top: 1em;
    margin-bottom: 1em;
}
.facility-name-btn {
    padding-left: 1em;
    padding-right: 1em;
    margin-bottom: 1em;
}
.icon {
    margin-left: 5px;
}
.add-motor{
    margin-top: 5rem;
    margin-left: 5rem;
}
.el-button.add-motor{
    background-color: $--color-primary;
    color: white;
}
.el-button.add-motor:hover{
    background-color: #001B6F;
    color: white;
    border-color: #001B6F;
}
.flex{
    display: flex;
    justify-content: center;
}
.home-layout{
    padding: 2rem 25rem;
}
.motor-cards{
    height: 55rem;
    max-height: 55rem;
    overflow-y: auto;
}
.no-motor{
    width: 45em;
    font-style: italic;
    text-align: center;
    margin-top: 2em;
    color: grey;
}
.back-to-portal{
    padding: 1rem 0 0 19rem;
    a {
        color: white;
    }
}
.legend-container{
    margin-left: 5rem;
    margin-top: 0.5rem;
    .legend{
        display: flex;
        gap: 0.5rem;
        align-items: center;
        margin-bottom: 0.5rem;
        .legend-square {
            width:20px;
            height:20px;
            border-radius: 4px;
            &.simple{
                background-color: #005BBA;
            }
            &.advanced{
                background-color: #455769;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/AutonomeHome.vue